import React, { useEffect, useState } from "react";
import { Container, ListItem,  ListItemText, Grid, List, Divider, IconButton} from '@mui/material';
import { useParams } from "react-router-dom";
import CommonListHeader from "components/layout/list/header";
import { useUsTiresDetailsQuery  } from "services/ustires";
import NhtsaDetails from './nhtsa-details';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


const UsTiresDetails = (props) => {
    
    const { id } = useParams();
    const [leftMenu, setLeftMenu] = useState('model');

    const {ustiresDetails, ustiresStatus, ustiresLoading, fetching} = useUsTiresDetailsQuery({id: id}, 
        {
            skip: !id,
            selectFromResult: ({ data, status, isLoading, isFetching }) => ({
                ustiresDetails: data || {},
                ustiresStatus: status,
                ustiresLoading: isLoading,
                fetching: isFetching
            })
        }
    );

    return (
        <React.Fragment>
            <CommonListHeader value = {{title: `DOT: ${ustiresDetails.tin} (${ustiresDetails.rangestart} - ${ustiresDetails.rangeend})`, description: "You are viewing Dot Range and details from ustires.org."}} />
            <Container maxWidth={false} disableGutters>
                <Grid container item md={12} display={'flex'} justifyContent={'space-between'} alignItems={'start'} sx={{padding: "10px"}}>
                    <Grid container item md={3} display={'flex'}>
                        <List sx={{
                            p: 0,
                            width: '100%',
                            borderRadius: 2,
                            border: '1px solid',
                            borderColor: 'divider',
                            backgroundColor: 'background.paper',
                        }}>
                            <ListItem>
                                <ListItemText primary="DOT" secondary= {`${ustiresDetails.tin}`} />
                            </ListItem>
                            <ListItem>
                                <ListItemText secondary= {`System will search for Tires starting with ${ustiresDetails.tin}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            <ListItem>
                                <ListItemText primary="Range" secondary= {`${ustiresDetails.rangestart || ''} - ${ustiresDetails.rangeend}`} />
                                
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            <ListItem>
                                <ListItemText primary="Manufacturer" secondary= {`${ustiresDetails.manufacturer || ''}`} />
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            <ListItem sx={{backgroundColor: `${leftMenu === 'brand' ? "#e7e3e3" : ''}`}}>
                                <ListItemText primary="Brand" secondary= {`${ustiresDetails.brand || ''}`} />
                                <IconButton  onClick={()=>setLeftMenu('brand')}><ArrowForwardIosIcon  fontSize="small" /></IconButton>
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            <ListItem sx={{backgroundColor: `${leftMenu === 'model' ? "#e7e3e3" : ''}`}}>
                                <ListItemText primary="Model" secondary= {`${ustiresDetails.model || ''}`} />
                                <IconButton  onClick={()=>setLeftMenu('model')}><ArrowForwardIosIcon  fontSize="small" /></IconButton>
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            <ListItem sx={{backgroundColor: `${leftMenu === 'size' ? "#e7e3e3" : ''}`}}>
                                <ListItemText primary="Size" secondary= {`${ustiresDetails.size || ''}`} />
                                <IconButton  onClick={()=>setLeftMenu('size')}><ArrowForwardIosIcon  fontSize="small" /></IconButton>
                            </ListItem>
                            <Divider variant="middle" flexItem  />
                            {/* <ListItem sx={{backgroundColor: `${leftMenu === 'custom' ? "#e7e3e3" : ''}`}}>
                                <ListItemText primary="Custom" secondary= {`Customized Records`} />
                                <IconButton onClick={()=>setLeftMenu('custom')}><ArrowForwardIosIcon fontSize="small" /></IconButton>
                            </ListItem> */}
                            <Divider variant="middle" flexItem  />
                            <ListItem sx={{backgroundColor: `${leftMenu === 'app' ? "#e7e3e3" : ''}`}}>
                                <ListItemText primary="Shown in APP" secondary= {`DOT from ${ustiresDetails.tin}${ustiresDetails.rangestart} - ${ustiresDetails.tin}${ustiresDetails.rangeend}`} />
                                <IconButton onClick={()=>setLeftMenu('app')}><ArrowForwardIosIcon fontSize="small" /></IconButton>
                            </ListItem>
                        </List>
                        

                            {/* <CardActions sx={{padding: "15px"}}>
                                <Button
                                    disabled={disableButton}
                                    variant="contained"
                                    color='primary'
                                    type="submit"
                                    onClick={() => navi(`/ustires/edit/${ustiresDetails?.id}`)}
                                >
                                    Add Recalls
                                </Button>
                                <Button
                                    disabled={disableButton}
                                    variant="outlined"
                                    type="submit"
                                    onClick={() => handleCancel()}
                                >
                                    Cancel
                                </Button>
                                <Typography sx={{flexGrow: 1}} />
                            
                            </CardActions> */}

                    </Grid>
                    <Grid container item md={9} display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{paddingLeft: "10px"}}>
                            <NhtsaDetails {...{leftMenu: leftMenu}}/>
                    </Grid>
                </Grid>
            </Container>
        </React.Fragment>
    )

    
}

export default UsTiresDetails;